import { Alert, Typography } from "antd";
import dayjs from "dayjs";
import EmailPreviewFrame from "../../../shared/emailEditor/EmailPreviewFrame";

const { Text } = Typography;

// The renewal email that already went out: when it was sent and exactly what the customer got
const SentEmailView = ({ sentEmail }) => {
  const sentAt = sentEmail.sent_at
    ? dayjs(sentEmail.sent_at).format("MMM D, YYYY h:mm A")
    : null;

  return (
    <div style={{ maxWidth: 800 }}>
      <Alert
        style={{ marginBottom: 16 }}
        type="success"
        showIcon
        message={
          sentAt
            ? `A renewal email was sent for this customer on ${sentAt}. Please refer to the renewal page for the latest status.`
            : "A renewal email has been sent for this customer. Please refer to the renewal page for the latest status."
        }
      />
      {sentEmail.reviewed_at && (
        <Alert
          type="info"
          showIcon
          message="Delivery was confirmed by an admin after an interruption. This is the copy prepared before sending."
          style={{ marginBottom: 16 }}
        />
      )}
      {sentEmail.body ? (
        <>
          <div style={{ marginBottom: 8 }}>
            <strong>Subject:</strong> {sentEmail.subject}
          </div>
          <EmailPreviewFrame html={sentEmail.body} title="Sent email" />
        </>
      ) : (
        <Text type="secondary">
          The content of this email was not recorded when it was sent.
        </Text>
      )}
    </div>
  );
};

export default SentEmailView;
